import _ from 'lodash';

// e.g. [...].filter(isPresent) will remove null & undefined
export const isPresent = <T,>(arg: T | undefined | null): arg is T =>
  !_.isNil(arg);

export type TObjPromise<T> = Promise<T> & {
  resolve: (value: T) => void;
  reject: (reason?: unknown) => void;
};

export const genPromise = <T,>(): TObjPromise<T> => {
  let resolve!: (value: T) => void;
  let reject!: (reason?: unknown) => void;
  const promise = new Promise<T>((resolveFn, rejectFn) => {
    resolve = resolveFn;
    reject = rejectFn;
  });

  return Object.assign(promise, { resolve, reject });
};
